import React, { useState, useContext, useEffect } from "react";
import {
  CNavbar,
  CContainer,
  CNavbarBrand,
  CNavbarToggler,
  CCollapse,
  CNavbarNav,
  CNavItem,
  CNavLink,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
} from "@coreui/react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../../BackendFirebase/isLoggedIn";
import { auth } from "../../../BackendFirebase/firebaseConfig";

const TopNavbar = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const user = useContext(UserContext);
  const [isLoggedIn, setIsLoggedIn] = useState(
    user !== null && user.emailVerified
  );

  useEffect(() => {
    setIsLoggedIn(user !== null && user.emailVerified);
  }, [user]);

  // Rest of the code
  const handleSignOut = async () => {
    try {
      await auth.signOut();
      navigate("/sign-in");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <>
      <CNavbar expand="lg" colorScheme="dark" className="bg-dark">
        <CContainer fluid>
          <CNavbarBrand onClick={() => navigate("/")}>ShowerAway</CNavbarBrand>

          <CNavbarToggler
            aria-label="Toggle navigation"
            aria-expanded={visible}
            onClick={() => setVisible(!visible)}
          />
          <CCollapse className="navbar-collapse" visible={visible}>
            <CNavbarNav className="me-auto mb-2 mb-lg-0">
              <CNavItem>
                <CNavLink onClick={() => navigate("/about")}>About Us</CNavLink>
              </CNavItem>
              {!isLoggedIn && (
                <>
                  <CNavItem>
                    <CNavLink onClick={() => navigate("/sign-in")}>
                      Sign In
                    </CNavLink>
                  </CNavItem>
                  <CNavItem>
                    <CNavLink onClick={() => navigate("/sign-up")}>
                      Sign Up
                    </CNavLink>
                  </CNavItem>
                </>
              )}
              {isLoggedIn && (
                <CDropdown variant="nav-item">
                  <CDropdownToggle
                    caret={false}
                    color="link"
                    className="nav-link"
                  >
                    My Account
                  </CDropdownToggle>
                  <CDropdownMenu>
                    <CDropdownItem onClick={() => navigate("/myprofile")}>
                      My Profile
                    </CDropdownItem>
                    <CDropdownItem onClick={handleSignOut}>
                      Sign Out
                    </CDropdownItem>
                  </CDropdownMenu>
                </CDropdown>
              )}
            </CNavbarNav>
          </CCollapse>
        </CContainer>
      </CNavbar>
    </>
  );
};

export default TopNavbar;
